import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import styles from './SettingsModal.module.css';
import { useTheme } from '../contexts/ThemeContext';
import { getCurrentUser } from '../utils/authService';

Modal.setAppElement('#root');

const SettingsModal = ({ isOpen, onClose, onSave }) => {
  const { theme, updateTheme } = useTheme();
  const [activeTab, setActiveTab] = useState('settings');
  const [tokenData, setTokenData] = useState({ balance: 0, used: 0 });
  const [settings, setSettings] = useState({
    theme: 'light',
    fontSize: 'medium',
    autoSave: true,
    notificationEnabled: true,
    language: 'en'
  });



  useEffect(() => {
    if (isOpen) {
      fetchTokenData();
    }
  }, [isOpen]);

  const fetchTokenData = async () => {
    const user = getCurrentUser();
    try {
      const [balanceRes, transactionsRes] = await Promise.all([
        fetch(`/api/tokens/balance/${user.user_id}`, {
          credentials: 'include' // ✅ Ensures authentication cookies are sent
        }),
        fetch(`/api/tokens/transactions/${user.user_id}`, {
          credentials: 'include' // ✅ Ensures authentication cookies are sent
        })
      ]);
      
  
      const [balance, transactions] = await Promise.all([
        balanceRes.json(),
        transactionsRes.json()
      ]);
  
      setTokenData({
        balance: balance.current_balance,
        used: balance.total_used,
        transactions
      });
    } catch (error) {
      console.error('Error fetching token data:', error);
    }
  };

const handleSave = () => {
  onSave(settings);
  onClose();
};

  return (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    className={styles.modal}
    overlayClassName={styles.overlay}
    style={{
      overlay: {
        zIndex: 1000000000000
      },
      content: {
        zIndex: 1000000000001
      }
    }}
  >
    <div className={styles.content}>
      <div className={styles.tabs}>
          <button 
            className={`${styles.tab} ${activeTab === 'settings' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            Settings
          </button>
          <button 
            className={`${styles.tab} ${activeTab === 'ai' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('ai')}
          >
            AI
          </button>
        </div>

        {activeTab === 'settings' && (
          <>
            <div className={styles.section}>
              <h3>Appearance</h3>
              <div className={styles.setting}>
                <label>Theme</label>
                <select
                  value={theme.name}
                  onChange={(e) => updateTheme(e.target.value)}
                >
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                  <option value="everGreen">everGreen</option>
                  <option value="bloomingmeadows">Blooming</option>
                  <option value="ringmaster">Ring Master</option>
                  

                  <option value="system">System Default</option>
                </select>
              </div>

              <div className={styles.setting}>
                <label>Font Size</label>
                <select
                  value={settings.fontSize}
                  onChange={(e) => setSettings({...settings, fontSize: e.target.value})}
                >
                  <option value="small">Small</option>
                  <option value="medium">Medium</option>
                  <option value="large">Large</option>
                </select>
              </div>
            </div>

            <div className={styles.section}>
              <h3>Editor</h3>
              <div className={styles.setting}>
                <label>
                  <input
                    type="checkbox"
                    checked={settings.autoSave}
                    onChange={(e) => setSettings({...settings, autoSave: e.target.checked})}
                  />
                  Enable Auto-Save
                </label>
              </div>
            </div>

            <div className={styles.section}>
              <h3>Notifications</h3>
              <div className={styles.setting}>
                <label>
                  <input
                    type="checkbox"
                    checked={settings.notificationEnabled}
                    onChange={(e) => setSettings({...settings, notificationEnabled: e.target.checked})}
                  />
                  Enable Notifications
                </label>
              </div>
            </div>

            <div className={styles.section}>
              <h3>Language</h3>
              <div className={styles.setting}>
                <select
                  value={settings.language}
                  onChange={(e) => setSettings({...settings, language: e.target.value})}
                >
                  <option value="en">English</option>
                  <option value="es">Español</option>
                  <option value="fr">Français</option>
                </select>
              </div>
              <div className={styles.buttons}>
          <button className={styles.saveButton} onClick={handleSave}>
            Save Changes
          </button>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
        </div>
            </div>
          </>
        )}

        {activeTab === 'ai' && (
          <div className={styles.aiSection}>
            <div className={styles.tokenInfo}>
              <div className={styles.tokenRow}>
                <span>Balance:</span>
                <span>{tokenData.balance}</span>
              </div>
              <div className={styles.tokenRow}>
                <span>Used:</span>
                <span>{tokenData.used}</span>
              </div>
            </div>
            <div className={styles.transactionBox}>
              <div className={styles.transactionTitle}>Transactions</div>
              {tokenData.transactions?.map(t => (
                <div key={t.transaction_id} className={styles.tokenRow}>
                  <span>{new Date(t.timestamp).toLocaleString()}</span>
                  <span>{t.request_type}: {t.tokens_used}</span>
                </div>
              ))}
            </div>
          </div>
        )}


      </div>
    </Modal>
  );
};

export default SettingsModal;